import { IsOptional, IsString } from 'class-validator';

import type { FsgmLocaleType } from '@common-lib';
import { IsCustomLocale } from '@common-lib';

export class UpdateUserModel {
  @IsString()
  @IsOptional()
  declare firstName: string | undefined;

  @IsString()
  @IsOptional()
  declare lastName: string | undefined;

  @IsCustomLocale()
  declare locale: FsgmLocaleType;
}
